import React from 'react';

const PermissionsContext = React.createContext({
  permissions: null,
  authorizationStrategy: null
});

export default PermissionsContext;
